// Site-wide constants: contact, images, social
export const CONTACT = {
  name: "Michael Moser",
  phone: "+43 0681 10 70 58 71",
  phoneLink: "+436811070871",
  email: "michael@lotussutra.at",
  street: "Forstweg 20",
  zip: "4020",
  city: "Linz",
  country: "Österreich",
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/lotussutra.at",
  facebook: "https://www.facebook.com/profile.php?id=61588872886842",
};

// Local images served from /images/ (bundled with the hosting package)
const I = (name) => `${process.env.PUBLIC_URL || ""}/images/${name}`;

export const IMAGES = {
  heroBuddha:     I("hero-buddha.jpg"),
  aboutPortrait:  I("about-portrait.jpeg"),
  offerLomi:      I("offer-lomi.jpg"),
  offerTibeter:   I("offer-tibeter.jpg"),
  koerperbalance: I("koerperbalance.jpg"),
  lomiOil1:       I("lomi-oil-1.jpg"),
  lomiOil2:       I("lomi-oil-2.jpg"),
  lomiOil3:       I("lomi-oil-3.jpeg"),
  buddhaMid:      I("buddha-mid.jpg"),
  gallery: [
    I("gallery-1.jpg"),
    I("gallery-2.jpg"),
    I("gallery-3.jpeg"),
    I("gallery-4.jpeg"),
    I("gallery-5.jpeg"),
    I("gallery-6.jpeg"),
  ],
};
